import { cx } from '@linaria/core';
import { mdiHeart } from '@mdi/js';
import { Icon } from '@mdi/react';
import type { IconProps } from '.';
import "./Friended.linaria.module.css!=!./Friended?./Friended.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNN8+JNzUvsywxr07Oz8kvsipLLNLQ1U1MLsksS9VNL0pNzdO0ruUCANJHd0MrAAAA"
// <Icon css={activeIconColor} {...props} />

const activeIconColor = "atm_7l_57v9t7";
const Friended = (props: IconProps) => {
  const {
    filled,
    color,
    size = 1,
    title,
    className,
    ...other
  } = props;
  return <Icon data-testid="IconButton__Friended" path={mdiHeart} title={title} size={size} color={color} {...other} className={cx(activeIconColor, className)} />;
};
export default Friended;